import React from 'react';

/* eslint-disable max-len */
const TickIcon = () => (
  <svg className='bb-tick-icon' viewBox='0 0 98.56 92.78'><path d='M39.6,93.39A8.3,8.3,0,0,1,33.75,91L3.15,60.36a8.27,8.27,0,0,1,11.7-11.7l23.5,23.51L84.14,4.26a8.27,8.27,0,0,1,13.72,9.25L46.46,89.74a8.28,8.28,0,0,1-6.07,3.61A7,7,0,0,1,39.6,93.39Z' transform='translate(-0.72 -0.61)'/></svg>
);

export default TickIcon;
